module.exports = __webpack_public_path__ + "media/virtual-gallery/GalleryFocus3-24a33076.jpg";